module.exports = __webpack_public_path__ + "img/sarah_broecker_8.64dc79dc.jpg";